"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./init"), exports);
(0, tslib_1.__exportStar)(require("./detail"), exports);
(0, tslib_1.__exportStar)(require("./readNews"), exports);
(0, tslib_1.__exportStar)(require("./deleteNews"), exports);
(0, tslib_1.__exportStar)(require("./centerList"), exports);
(0, tslib_1.__exportStar)(require("./centerDetail"), exports);
//# sourceMappingURL=index.js.map